import React from 'react';
import './table.component.style.less';
import { Layout } from 'antd';
import GeneralInfo from '../TableComponent/GeneralInfoComponent/generalInfo.component'
import BussinesPlan from './BussinesPlan/bussinesPlan.component'
import ElevatorPitch from './ElevatorPitch/elevatorPitch.component'
import AccountSettings from './AccountSettings/accountSettings.component'
import LeaderBoard from './LeaderBoard/leaderboardUser.component'

const { Content } = Layout;

const Table = ({ selectedContent }) => {

    const MenuSwitch = () => {
        switch (selectedContent) {
            case '1':
                return (
                    <Layout className="site-layout">
                        <Content
                            className="site-layout-background"
                            style={{
                                margin: '24px 16px',
                                padding: 24,
                                minHeight: 280,
                            }}
                        >
                            <AccountSettings />
                        </Content>
                    </Layout>
                );
            case '2':
                return (
                    <Layout className="site-layout">
                        <Content
                            className="site-layout-background"
                            style={{
                                margin: '24px 16px',
                                padding: 24,
                                minHeight: 280,
                            }}
                        >
                            <GeneralInfo />
                        </Content>
                    </Layout>
                );
            case '3':
                return (
                    <Layout className="site-layout">
                        <Content
                            className="site-layout-background"
                            style={{
                                margin: '24px 16px',
                                padding: 24,
                                minHeight: 280,
                            }}
                        >
                            <ElevatorPitch />
                        </Content>
                    </Layout>
                );
            case '4':
                return (
                    <Layout className="site-layout">
                        <Content
                            className="site-layout-background"
                            style={{
                                margin: '24px 16px',
                                padding: 24,
                                minHeight: 280,
                            }}
                        >
                            <BussinesPlan />
                        </Content>
                    </Layout>
                );
            case '5':
                return (
                    <Layout className="site-layout">
                        <Content
                            className="site-layout-background"
                            style={{
                                margin: '24px 16px',
                                padding: 24,
                                minHeight: 280,
                            }}
                        >
                            <LeaderBoard />
                        </Content>
                    </Layout>
                );
            default:
                break;
        }
    };

    return (
        <div className="content-switch">
            <MenuSwitch />
        </div>
    );
}


export default Table;